import Axios from "axios";
import {
  SET_SALES_CUSTOMER_KPI_REPORT_LIST,
  UNSET_SALES_CUSTOMER_KPI_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getSalesCustomerKpiReport,
} from "@/store/api";

const state = { 
  getSalesCustomerKpiReport: [],
};

const getters = {
  getSalesCustomerKpiReport(state) {
    return state.getSalesCustomerKpiReport;
  },
};

const mutations = {
  [SET_SALES_CUSTOMER_KPI_REPORT_LIST](state, data) {
    state.getSalesCustomerKpiReport = data;
  },
  [UNSET_SALES_CUSTOMER_KPI_REPORT_LIST](state) {
    state.getSalesCustomerKpiReport = [];
  },
};

const actions = {
  getSalesCustomerKpiReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(`${getSalesCustomerKpiReport}`, data)
        .then((response) => {
          commit(SET_SALES_CUSTOMER_KPI_REPORT_LIST, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          commit(UNSET_SALES_CUSTOMER_KPI_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,  
  getters,
  actions,
  mutations,
};

